var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmailServiceSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0.5H5C3.8 0.5 2.66 0.98 1.82 1.82C0.98 2.66 0.5 3.8 0.5 5V41C0.5 42.2 0.98 43.34 1.82 44.18C2.66 45.02 3.8 45.5 5 45.5H59C60.2 45.5 61.34 45.02 62.18 44.18C63.02 43.34 63.5 42.2 63.5 41V5C63.5 3.8 63.02 2.66 62.18 1.82C61.34 0.98 60.2 0.5 59 0.5ZM54.05 5L32 20.27L9.95 5H54.05ZM5 41V7.04L30.71 24.83C31.1 25.1 31.52 25.22 32 25.22C32.48 25.22 32.9 25.07 33.29 24.83L59 7.04V41H5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmailServiceSettings);
export default __webpack_public_path__ + "static/media/ic-email-service-settings.6d83a495d8e4a3df7381b0aee4bfc11e.svg";
export { ForwardRef as ReactComponent };